export const BUTTON_TYPE_PRIMARY = 'primary'
export const BUTTON_TYPE_SECONDARY = 'secondary'
export const BUTTON_TYPE_TERTIARY = 'tertiary'
